/* ===========================
 * User Transformer
 * ===========================
 *
 * The transformer for the user
 */

import store from '../store';
import Transformer from './transformer';

export default class UserTransformer extends Transformer {
  /**
   * Method used to transform a fetched user
   *
   * @param user The fetched user
   *
   * @returns {Object} The transformed user
   */

  static fetch(user) {
    return {
      id: user.id,
      email: user.email,
      tel: user.tel,
      email_confirmed: user.email_confirmed,
      tel_confirmed: user.tel_confirmed,
      email_new: user.email_new,
      tel_new: user.tel_new,
      tel_verification_expired: user.tel_verification_expired,
      otp_ref: user.otp_ref || '',
      email_verification_expired: user.email_verification_expired, // for cooldown
      wallet: user.wallet, // in Satang (not Baht)
      timezone: user.timezone, // for cooldown
      settings: user.settings,
      support_pin: user.support_pin,
      social: user.social,
      social_only: user.social_only,
      latest_analytic: user.latest_analytic,
      // emergency_tel: user.emergency_tel,
    };
  }

  static register(user) {
    const payload = UserTransformer.convertUsernameToEmailOrTel(user);
    payload.lat = store.state.auth.latitude;
    payload.long = store.state.auth.longitude;
    return payload;
  }

  static login(user) {
    const payload = UserTransformer.convertUsernameToEmailOrTel(user);
    return payload;
  }

  static addAdmin(user) {
    const result = window._.cloneDeep(user);
    if (result.user.includes('@')) {
      result.email = result.user;
    } else {
      result.user_id = result.user;
    }
    delete result.user;
    return result;
  }

  static forgetPassword(user) {
    // return UserTransformer.convertUsernameToEmailOrTel(Object.assign({}, user));
    const result = {};
    if (user.username.includes('@')) {
      result.email = user.username;
      result.tel = '';
    } else {
      result.tel = UserTransformer.normalizedTel(user.username);
      result.email = '';
    }

    return result;
    /* return {
     email: user.email,
     tel: UserTransformer.normalizedTel(user.tel),
     }; */
  }

  static forgetPasswordProvider(user) {
    const result = {
      type: 'provider',
    };
    if (user.username.includes('@')) {
      result.email = user.username;
      result.tel = '';
    } else {
      result.tel = UserTransformer.normalizedTel(user.username);
      result.email = '';
    }

    return result;
  }

  static forgetPasswordRevert(user) {
    return UserTransformer.convertEmailOrTelToUsername(Object.assign({}, user));
    // if (user.email) {
    //   return { username: user.email };
    // }
    // return { username: user.tel };
  }

  /* static getTokenByPhone(user) {
    return {
      code: user.code,
      tel: UserTransformer.normalizedTel(user.tel),
    };
  } */

  static normalizedTel(tel) {
    let retval = tel;

    if (retval.substring(0, 1) === '0') {
      retval = `+66${retval.substring(1)}`;
    }

    return retval;
  }

  static convertUsernameToEmailOrTel(user) {
    const result = window._.cloneDeep(user);
    if (result.username.includes('@')) {
      result.email = result.username;
      result.tel = '';
    } else {
      result.tel = UserTransformer.normalizedTel(result.username);
      result.email = '';
    }
    delete result.username;
    return result;
  }

  static convertEmailOrTelToUsername(user) {
    const result = window._.cloneDeep(user);
    if (result.email) {
      result.username = result.email;
      delete result.email;
    } else {
      result.username = result.tel;
      delete result.tel;
    }
    return result;
  }

  static mainOrganization(user) {
    const mainEmployee = this.mainEmployee(user);
    if (mainEmployee) {
      return mainEmployee.organization;
    }
    return null;
  }

  static hasOrganizationPrivilege(user, requiredQuota) {
    const employee = this.mainEmployee(user);
    const organization = this.mainOrganization(user);
    if (organization && organization.active) {
      const hasEnoughEmployeeQuota = employee.quota === null || employee.quota >= requiredQuota;
      const hasEnoughWalletTime =
        organization.package_type === 'free' ||
        (organization.package_type === 'time' && organization.wallet_time * 30 >= requiredQuota);
      return hasEnoughEmployeeQuota && hasEnoughWalletTime;
    }
    return false;
  }

  static hasOrganizationPrivilegeForProvider(user, requiredQuota, provider) {
    if (!(provider && provider.id)) {
      return false;
    }
    const employee = this.mainEmployee(user);
    const organization = this.mainOrganization(user);
    if (
      employee &&
      employee.active &&
      organization &&
      organization.active &&
      provider.visibility.includes('organization')
    ) {
      let isProviderEligible = organization.eligible_provider_types.length === 0;
      if (!isProviderEligible) {
        isProviderEligible = organization.eligible_provider_types.includes(provider.type);
      }
      const hasEnoughEmployeeQuota = employee.quota === null || employee.quota >= requiredQuota;
      const hasEnoughWalletTime =
        organization.package_type === 'free' ||
        (organization.package_type === 'time' && organization.wallet_time * 30 >= requiredQuota);
      return hasEnoughEmployeeQuota && hasEnoughWalletTime && isProviderEligible;
    }
    return false;
  }

  static organizationPrivilegeLeftForProvider(user, visitDuration, provider) {
    const employee = this.mainEmployee(user);
    if (employee && provider && provider.id) {
      if (employee.quota) {
        return employee.quota / visitDuration;
      }
      return employee.quota;
    }
    return 0;
  }
}
